import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { CompanyEffectivePermission } from '../types/account';

type Props = {
  userUniqueId: string
}

/**
 * The current user's own effective permissions, per company, exactly as the server computes them.
 *
 * This is the source of truth for what the UI may show. It replaces reconstructing capabilities
 * client-side from CompanyRole names, which could not see service-account scope (a member holds
 * permissions with no CompanyRole row at all) and only approximated group/tenant cascade.
 */
export function useQueryEffectivePermissions({ userUniqueId }: Props) {
  return useQuery<CompanyEffectivePermission[]>({
    queryKey: ['config.effectivePermissions', userUniqueId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/config-api/user/effective-permissions`);
      return data;
    },
    staleTime: MINUTE_IN_MS * 5, // matches useQueryAccount/useQueryRoles
  });
}
